import { useEffect, useState } from 'react';
import { apiEndPoints } from '../common/api.endPoints';
import { ConfigService } from '../common/config.service';
import { clientEnvVars } from '../common/environment/clientEnvVars';
import { HttpService } from '../common/http.service';

export const useClientConfig = () => {
  const noraSubdir = clientEnvVars().NORA_SUBDIR;
  const [clientConfig, setClientConfig] = useState({
    isReady: false,
    error: null,
    securityProps: {
      issuer: '',
      clientId: '',
      redirectUri: `${window.location.origin}/${noraSubdir}/implicit/callback`,
    },
    flags: {},
  });

  useEffect(() => {
    (async () => {
      try {
        const response = await HttpService.getInstance().get(
          apiEndPoints.clientConfig,
        );

        if (response && !response.error) {
          const { issuer, clientId, logoutUrl, flags } = response.parsedBody;
          console.debug('Received client config');
          ConfigService.getInstance().setConfig({
            issuer,
            clientId,
            logoutUrl,
          });

          setClientConfig({
            isReady: true,
            error: null,
            securityProps: {
              issuer,
              clientId,
              redirectUri: clientConfig.securityProps.redirectUri,
            },
            flags,
          });
        } else {
          const err =
            response?.error || new Error('Failed to fetch client config');
          console.error('Failed to fetch client config', err);
          setClientConfig({
            isReady: true,
            error: err,
            securityProps: clientConfig.securityProps,
            flags: clientConfig.flags,
          });
        }
      } catch (e) {
        const err = e instanceof Error ? e : new Error(String(e));
        console.error('Failed to fetch client config', err);
        setClientConfig({
          isReady: true,
          error: err,
          securityProps: clientConfig.securityProps,
          flags: clientConfig.flags,
        });
      }
    })();
  }, []);

  return clientConfig;
};
